import React, { ComponentProps } from 'react';
import ThumbnailGallery, { GalleryImage } from '../partials/Galleries/ThumbnailGallery';
import { useBlockContext } from '../../../_lib/BlockFetcher';
import { asView } from '../../../_lib/ViewFetcher';
import { SliderGallery } from '../partials/Galleries/SliderGallery';

export type ImageGalleryDefaultViewProps = {
  images: GalleryImage[];
  layout: string;
};

function DefaultView({ images = [], layout }: ImageGalleryDefaultViewProps) {
  const { uuid } = useBlockContext();
  if (layout === 'slider') {
    return <SliderGallery id={uuid} images={images} />;
  }
  return <ThumbnailGallery id={uuid} images={images} />;
}

export const ImageGalleryDefaultView = asView(DefaultView);
export type ImageGalleryDefaultView = ComponentProps<typeof ImageGalleryDefaultView>;
